// Test send for a client advertising report. The backend only accepts the
// signed-in user's own address, so this dialog never offers a free-text
// recipient and never touches the schedule's saved client recipients.
import PropTypes from 'prop-types';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import EmailText from './EmailText';

// The app's global stylesheet capitalises every word inside a button, which
// turns a real address into Staging_admin@Dental-Sem.Co.Uk. An address is not
// a label, so it is shown as body text and the button says what it does.

export default function ClientTestSendDialog({ schedule, email, state, onClose }) {
    return (
        <Dialog open={!!schedule} onClose={state.busy ? undefined : onClose} fullWidth maxWidth="sm">
            <DialogTitle>Send a test to yourself</DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Typography>{schedule?.title}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Recipient
                    </Typography>
                    <EmailText sx={{ fontWeight: 600, wordBreak: 'break-all' }}>
                        {email || 'Signed-in email unavailable'}
                    </EmailText>
                    <Typography variant="body2">
                        Uses the saved report settings and selected calendar period. Incomplete data blocks delivery.
                        This action sends an email to your signed-in address only.
                    </Typography>
                    {state.error && <Alert severity="error">{state.error}</Alert>}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button disabled={state.busy} onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    disabled={state.busy || !email}
                    onClick={async () => {
                        const result = await state.testSend(schedule, email);
                        if (result) onClose();
                    }}
                >
                    Send test to my own address
                </Button>
            </DialogActions>
        </Dialog>
    );
}

ClientTestSendDialog.propTypes = {
    schedule: PropTypes.object,
    email: PropTypes.string,
    state: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
};
